import request from './index'

/**
 * 查询任务类型列表（含每个类型下的任务）
 * @param {Object} params - 分页参数
 * @param {number} params.page - 当前页（默认1）
 * @param {number} params.pageSize - 每页条数（默认10）
 * @param {number} params.status - 状态（默认4）
 * @returns {Promise}
 */
export function getCategoryList(params = {}) {
  return request({
    url: '/api/task/category/list',
    method: 'post',
    data: {
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      status: params.status !== undefined ? params.status : 4
    }
  })
}
